import React from 'react';
import classnames from 'classnames';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';
import useDynamicReactIcon from 'v2/hooks/useDynamicReactIcon';
import { mapNoteSeverity } from 'v2/utils/noteUtils';
import { getIconColorBySeverity } from 'v2/utils/iconUtils';
import ExtendedTooltip from 'v2/common/ExtendedRequest/ExtendedTooltip';
import { FreeSearchTooltip } from '../FreeSearchTooltip/FreeSearchTooltip';
import { ExpiredTooltip } from './ExpiredTooltip/ExpiredTooltip';

const Title = ({ search }: ColumnComponentProps) => {
  const Icon = useDynamicReactIcon(search.note?.icon || '');
  const noteSeverity = search.note?.severity
    ? mapNoteSeverity(search.note.severity)
    : undefined;

  return (
    <div
      className={classnames(
        'pr-1 text-dark',
        'd-flex align-items-center',
        'search-title'
      )}
    >
      <ExpiredTooltip {...search} />

      <FreeSearchTooltip isFreeSearch={search.free} />
      <p className="text-truncate">{search.name}</p>

      <ExtendedTooltip
        extended={search.extended}
        expires_at={search.expires_at}
        isFreeSearch={search.free}
      />

      {Icon ? (
        <div className="w-20">
          <Icon
            className={classnames(
              'ml-2 mr-2',
              getIconColorBySeverity(noteSeverity || '')
            )}
            size={22}
            aria-label={`${noteSeverity}SearchNoteIcon`}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Title;
